<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
        <div *ngIf="!accessdenied" class="col-xs-12 col-sm-12 col-lg-12 largTextbox" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Create new article</span>
            </h6>
        </div>
        <div *ngIf="!accessdenied" class="col-sm-12">
            <div class="card" style="border-top-right-radius: 0px; border-top-left-radius: 0px; border-bottom-right-radius: 5px; border-bottom-left-radius: 5px; ">
                <div class="row" style="padding:20px">
                    <div class="form theme-form">
                        <div class="row">
                            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                                <div class="form-floating">
                                    <input [(ngModel)]="article.title" type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">Title</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom: 20px; padding-right: 5px !important">
                                <div class="form-floating">
                                    <input [(ngModel)]="article.authorName" type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">Author name</label>
                                </div>
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px; padding-left:5px !important">
                                <div class="form-floating">
                                    <input [(ngModel)]="article.source" type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">Article source</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom: 20px; padding-right: 5px !important">
                                <div class="form-floating">
                                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example" (change)="selectArticleTypeOption($event)">

                                        <option value="internal">
                                            Internal
                                        </option>
                                        <option value="external">
                                            External
                                        </option>
                                    </select>
                                    <label for="floatingSelect">Type</label>
                                </div>
                            </div>
                            <div *ngIf="article.navigateType == 'external'" class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px; padding-left:5px !important">
                                <div class="form-floating">
                                    <input [(ngModel)]="article.navigateUrl" type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">URL</label>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="article.navigateType == 'internal'" class="row">
                            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                                <div class="form-floating">
                                    <quill-editor [(ngModel)]="article.article" [styles]="{height: '400px'}"></quill-editor>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                                <div class="form-floating">
                                    <div class="col-xl-12 no-padding form-group">
                                        <input type="file" name="file" id="fileCover" class="inputfile" (change)="fileChangeEventCover($event)" />
                                        <label for="fileCover" style="border: 1px solid lightgrey;border-radius: 5px;padding: 10px;">Browse Article Cover Image</label>
                                        <!--<input type="file" (change)="fileChangeEvent($event)" />-->
                                    </div>
                                    <div class=" col-xl-12">
                                        <image-cropper [imageChangedEvent]="imageChangedEventCover"
                                                       [maintainAspectRatio]="true"
                                                       [aspectRatio]="4 / 2"
                                                       [resizeToWidth]="750"
                                                       format="png"
                                                       (imageCropped)="imageCroppedCover($event)"
                                                       (imageLoaded)="imageLoadedCover()"
                                                       (loadImageFailed)="loadImageFailedCover()"></image-cropper>
                                    </div>
                                    <div class="col-xl-12 no-padding form-group">
                                        <img [src]="croppedImageCover" />
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding">
                            <button [disabled]="btnVerifyDisabled" style="float: right;" class="btn mygistec-main-btn" (click)="submitArticle()">{{btnVerifyText}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

